import { useAuthentication } from './api/useAuthentication';

export function useUser() {
  const { user } = useAuthentication();
  return user;
}

export function useIsLumeoAdmin() {
  const { user } = useAuthentication();

  if (!user) {
    return false;
  }

  return user.roles.some(
    ({ name, organization_id, application_id }) =>
      name === 'admin' && !application_id && !organization_id
  );
}
